/*
  lx1-companion-app.js — behaviour for the LX1 "Companion app" card slider (sections/lx1-pdp-companion-app.liquid,
  styles in assets/lx1-companion-app.css). Loaded deferred; no dependencies.
  A native scroll-snap track standing in for the Moasure 2 band's Swiper slider, with the same controls:
  - one dot per stop, worked out the way Swiper builds its snap grid: every card start that can reach the left edge,
    plus the end of the track when that is more than a pixel further on (5 cards at 1440px = 3 dots, as on M2);
  - the arrows move one stop and fade out (disabled) at either end; a dot jumps to its stop.
  Rebuilt on resize. Idempotent per section; re-runs on theme-editor section reloads.
*/
(function () {
  function init(sec) {
    var track = sec.querySelector('[data-lx1app-track]');
    if (!track || track.getAttribute('data-lx1app-init')) return;
    track.setAttribute('data-lx1app-init', '1');
    var dots = sec.querySelector('[data-lx1app-dots]');
    var prev = sec.querySelector('[data-lx1app-prev]');
    var next = sec.querySelector('[data-lx1app-next]');
    var cards = track.children;
    if (!cards.length) return;

    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function stops() {
      var m = maxScroll(), base = cards[0].offsetLeft, out = [];
      for (var i = 0; i < cards.length; i++) {
        var p = cards[i].offsetLeft - base;
        if (p <= m) out.push(p);
      }
      if (Math.floor(m) - Math.floor(out[out.length - 1]) > 1) out.push(m);
      return out;
    }
    function current(s) {
      var x = track.scrollLeft, best = 0;
      for (var i = 1; i < s.length; i++) if (Math.abs(s[i] - x) < Math.abs(s[best] - x)) best = i;
      return best;
    }
    function goTo(i) {
      var s = stops();
      track.scrollTo({ left: s[Math.max(0, Math.min(s.length - 1, i))], behavior: 'smooth' });
    }
    function buildDots() {
      if (!dots) return;
      var n = stops().length, label = dots.getAttribute('data-label') || '';
      dots.hidden = n < 2;
      while (dots.children.length > n) dots.removeChild(dots.lastChild);
      while (dots.children.length < n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lx1app__dot';
        b.setAttribute('aria-label', label + ' ' + (dots.children.length + 1));
        dots.appendChild(b);
      }
    }
    function update() {
      var idx = current(stops());
      if (dots) Array.prototype.forEach.call(dots.children, function (d, i) {
        d.classList.toggle('is-active', i === idx);
        if (i === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= maxScroll() - 4;
    }

    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { goTo(current(stops()) - 1); });
    if (next) next.addEventListener('click', function () { goTo(current(stops()) + 1); });
    if (dots) dots.addEventListener('click', function (e) {
      var d = e.target.closest ? e.target.closest('.lx1app__dot') : null;
      if (d) goTo(Array.prototype.indexOf.call(dots.children, d));
    });
    window.addEventListener('resize', function () { buildDots(); update(); }, { passive: true });
    buildDots();
    update();
  }

  function initAll() { Array.prototype.forEach.call(document.querySelectorAll('[data-lx1app]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true }); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
